import Controller from '../abstracts/Controller';
import 'scss-templates/t-landing.scss';

export default class LandingController extends Controller {
  static get COMPONENTS() {
    return [
      'LanguageComponent',
      'DropdownLandingComponent',
      'ModalComponent'
    ];
  }
}
